module.exports = __webpack_public_path__ + "static/media/Bicubik.2282d65f.otf";